import { ConversationsListStatus } from '@app/hooks'
import { ConversationItem, ReplyDetectionStatus } from '@app/models'

const spamConversationStatuses: Set<ConversationItem['status']> = new Set([
  'Spam',
  'DispatchedAndSpam',
])

type ConversationFilters = {
  status: ConversationsListStatus
  replyDetectionStatus?: ReplyDetectionStatus
}

export const extractConversationFilters = (
  params: URLSearchParams
): ConversationFilters => {
  const statusParam = params.get('status')
  const status: ConversationsListStatus =
    statusParam === 'spam' ? 'spam' : 'dispatched'

  const replyDetectionStatusParam = params.get('replied')
  const replyDetectionStatus: ReplyDetectionStatus | undefined =
    replyDetectionStatusParam === 'true'
      ? 'Replied'
      : replyDetectionStatusParam === 'false'
        ? 'Unreplied'
        : undefined

  return { status, replyDetectionStatus }
}

export const shouldKeepConversation = (
  conversation: ConversationItem | undefined,
  { status, replyDetectionStatus }: ConversationFilters
) => {
  if (!conversation) {
    return false
  }

  const statusMatches =
    status === 'spam'
      ? spamConversationStatuses.has(conversation.status)
      : !spamConversationStatuses.has(conversation.status)

  if (!statusMatches) {
    return false
  }

  if (replyDetectionStatus) {
    return conversation.replyDetectionStatus === replyDetectionStatus
  }

  return true
}
